/**
 * Created by nemio on 27.11.2015.
 */

import moment from 'moment';

moment.updateLocale('en_US', {
  calendar: {
    lastDay: '[Yesterday]',
    sameDay: '[Today]',
    nextDay: '[Tomorrow]',
    lastWeek: '[Last] dddd',
    nextWeek: '[Next] dddd',
    sameElse: '[Earlier]'
  }
});

const en_US = {
  yes: 'Yes',
  no: 'No',
  no_thanks: 'No, thank you',
  loading: 'Loading...',
  global_error: 'Sorry, site is unavailable due technicals reason. Please, try again later',
  email: 'Email',
  password: 'Password',
  close: 'Close',
  favorites: 'Favorites',
  search: 'Search',
  related: 'Related',
  tv: 'TV Channels',
  movies: 'Movies',
  tvseries: 'TV Series',
  on_now: 'TV Guide',
  cartoons: 'Cartoons',
  purchases: 'Purchases',
  premiere: 'New in theaters',
  my_services: {
    my_services: 'My services',
    my_rents: 'My content',
    my_subscriptions: 'My subscriptions',
    subscriptions: 'Subscribe',
    rents: 'Rent'
  },
  page: {
    home: 'Home',
    epg: 'TV Guide',
    favorites: 'Favorites',
    notifications: 'Notifications',
    records: 'My records',
    purchases: 'Purchases',
    related: 'Related',
    search: 'Search',
    collection: 'Collection'
  },
  error: {
    invalid_credentials: 'Login or password is wrong',
    invalid_credentials_description: ' ',
    blocked_subscription: 'Dear Subscriber, your subscription is not available at this moment. Please add money to your personal account. Thank you',
    'invalid credentials': 'The old password is incorrect',
    'passwords mismatch': 'The passwords must match.',
    'username field empty': 'Email field should not be empty.',
    'already exist': 'This email is not available. Please choose another email address or Sign In',
    'password field empty': 'Password field should not be empty.',
    'password too short': 'The password must be at least 6 characters. When generating, you can use letters, numbers, and any special characters.',
    'invalid password reset code': 'Invalid confirmation Code',
    'invalid ack': 'Confirmation code invalid',
    'invalid pin': 'Invalid pin code'
  },
  registration: {
    texts: {
      button: 'Create account',
      title: 'Register now!',
      description: 'If you have not registered yet please do it'
    }
  },
  login: {
    login: 'Email',
    login_example: 'name@domain.com',
    lost_your_password: 'Lost your password?',
    logout: 'Logout',
    log_in: 'Login'
  },
  forgot_password: {
    login: 'Email',
    login_example: 'name@domain.com',
    lost_your_password: 'Lost your password?',
    forgot_password: 'Forgot password?',
    send: "Send",
    recovery_password: "Recovery password",
    empty_field: "Empty field",
    wrong_email: "Wrong email",
    reset_password_success_message: "You will receive an email with a link to reset your password.",
    reset_password_error_message: "You will receive an email with a link to reset your password.",
  },
  profile: {
    movie: {
      bundle: 'Bundle',
      min: 'min',
      fav_add: 'Add to favorites',
      fav_remove: 'Remove from favorites',
      trailer: 'Trailer',
      youtube_trailer: 'Youtube Trailer',
      multiscreen: 'Continue on another screen',
      related: 'Related',
      share: 'Share',
      select_screen: 'Select screen'
    },
    tvSeries: {
      bundle: 'Bundle',
      min: 'min',
      fav_add: 'Add to favorites',
      fav_remove: 'Remove from favorites',
      trailer: 'Trailer',
      multiscreen: 'Continue on another screen',
      related: 'Related',
      share: 'Share',
      select_screen: 'Select screen',
      seasons: 'Seasons',
      episodes: 'Episodes',
      season_short: 'S', //S01E12
      episode_short: 'E', //S01E12
    },
    channel: {
      calendar: {
        before: 'Before',
        previously: 'Previously',
        now: 'Now',
        after: 'Next',
        hereafter: 'Later',
        yesterday: 'Yesterday',
        yesterday_at: 'Yesterday at',
        today: 'Today',
        today_at: 'Today at',
        tomorrow: 'Tomorrow',
        tomorrow_at: 'Tomorrow at',
        last: 'Last'
      },
      epg: 'EPG',
      bundle: 'Bundle',
      min: 'min',
      fav_add: 'Add to favorites',
      fav_remove: 'Remove from favorites',
      record_add: 'Add record',
      record_remove: 'Delete record',
      schedule_remove: 'Cancel record',
      multiscreen: 'Continue on another screen',
      share: 'Share',
      select_screen: 'Select screen'
    },
    subscription: {
      subscription: 'Subscription',
      included: 'Included',
      expires: 'Expires',
      bought: 'Bought',
      owned: 'Owned',
      subscription_period_end: 'Next payment date',
      subscription_period_start: 'Subscription start date',
      subscription_states: {
        active: 'Active',
        trialing: 'Trial',
        unpaid: 'Waiting payment',
        '_': 'Unknown'
      },
      cancel: 'Cancel subscription',
      canceled: 'Canceled',
      first_payment: 'First payment',
      details: 'Details',
      status: 'Status',
      are_you_sure: 'Are you sure',
      cancel_desc: 'You want to cancel your subscription for',
      re_subscribe: 'You can re-activate your subscription only after the end of the current period.',
      yes: 'Yes',
      no: 'No'
    },
    packages: {
      included: 'Included',
      expires: 'Expires',
      bought: 'Bought',
      owned: 'Owned'
    },
    epg_event: {
      remind_me: 'Remind me',
      not_remind: 'Not to remind',
      record_add: 'Add record',
      record_remove: 'Delete record',
      schedule_remove: 'Cancel record'
    },
    notification: {
      remind_me: 'Remind me',
      not_remind: 'Not to remind',
    },
    npvr: {
      record_add: 'Add record',
      record_remove: 'Delete record',
      schedule_remove: 'Cancel record'
    },
    ratings: {
      rating_delimiter: '/'
    },
    persons: {
      operator: 'Operator',
      assembly: 'Assembly',
      actor: 'Actor',
      director: 'Director',
      scenario: 'Scenario',
      composer: 'Composer',
      presenter: 'Presenter',
      music_director: 'Music Director',
      playback_singers: 'Playback Singers',
      _: 'other'
    },
    offers: {
      type: {
        'free': 'Free',
        'transactional-own': 'Buy',
        'transactional-rent': 'Rent',
        'subscription': 'Subscribe',
        'transactional-own-bundle': 'Buy in bundle',
        'transactional-rent-bundle': 'Rent in bundle',
        'subscription-bundle': 'Subscribe in bundle',
        '_': 'Other'
      },
      pay_as_you_go: 'Purchase offers',
      select_bundle: 'Select bundle',
      or: 'or',
      free_trial: 'free trial',
      free_trial_description: 'After that a subscription fee will be withdrawn from your account.',
      unit: {
        hour: 'Hour',
        day: 'Day',
        week: 'Week',
        month: 'Month',
        year: 'Year',
      }
    }
  },
  player: {
    no_signal: 'No signal',
    reload: 'Reload',
    youtube_connection_error: 'Youtube connection error'
  },
  more_menu_items: 'More',
  empty_section: 'Current section is empty',
  empty_result: 'No result',
  epg: {
    no_data: 'No data',
    now: 'Now',
    today: 'Today'
  },
  npvr: {
    filters: {
      status: 'Sort by recording state',
      date: 'Sort by recording date',
      alphabet: 'Sort by recording title',
      channel: 'Sort by recording channel'
    },
    status: {
      pending: 'Pending',
      scheduled: 'In schedule',
      recording: 'In progress',
      finished: 'Finished',
      failed: 'Failed',
      cancelled: 'Canceled by user'
    },
    usage: 'Usage',
    limit_desc: 'This indicates how much space you have used out of the total space available.',
    limit_desc_warning: 'You almost reached limit of recorded programs',
    limit_desc_reached: 'You have reached your nPVR recordings limit, please remove some existing recordings to free space.'
  },
  genres: 'Genres',
  messages: {
    pin: {
      title: 'Enter your PIN code',
      new_title: 'Enter new PIN code',
      ok: 'OK',
      cancel: 'Cancel'
    },
    notification: {
      title: 'Reminder on ',
      on_channel: 'On channel',
      is_switch_show_right_now: 'starts in 5 minutes. Switch to show right now?'
    },
    share_request: {
      title: 'Share ',
      vod: 'video',
      live: 'channel',
      you_have_received: 'You have received',
      sharing_notification: 'sharing notification. Do you want to watch?'
    },
    bookmark: {
      title: 'Continue watching?',
      continue_from: 'Continue from',
      start_over: 'Start over'
    }
  },
  settings: {
    settings: 'Settings',
    tabs: {
      login: {
        title: 'Login',
        email: 'Email',
        password: 'Password',
        sign_in: 'Sign in',
        error: 'Login or password is wrong.',
        success: 'Welcome back dear customer!'
      },
      registration: {
        title: 'Registration',
        email: 'Email',
        password: 'Password',
        password2: 'Confirm password',
        first_name: 'Name',
        last_name: 'Last name',
        sign_up: 'Sign up',
        success: "Thanks you for your registration!",
        need_confirmation: "A registration message was sent to your email address.  Please open your email, and click on the link to confirm your registration.",
      },
      registration_confirm: {
        success: "Thank you for registration. Your login and password can now be used on other devices where this service is available."
      },
      language: {
        title: 'Language',
        select_language: 'Select language:'
      },
      parental_control: {
        title: 'Parental control',
        description: 'Enable parental control',
        on: 'On',
        off: 'Off'
      },
      change_password: {
        title: 'Change password',
        save: 'Save',
        old_password: 'Old Password',
        new_password: 'Please enter a new password',
        new_password2: 'Confirm password',
        success: 'Password updated successfully'
      },
      reset_password: {
        title: 'Reset password',
        save: 'Save',
        enter_new_password: 'Please enter a new password',
        ack: 'Confirmation Code',
        password: 'New Password',
        success: 'Password updated successfully'
      },
    },
  },
  toast: {
    type: {
      record: 'Record',
      favorite: 'Favorite',
      notification: 'Notification',
      purchase: 'Purchase',
      service: 'Service',
      cookies: 'Cookies',
      adblock: 'Ad block'
    },
    operation: {
      record_add_success: 'Schedule recording was successful',
      record_add_fail: 'Schedule recording failed',
      record_remove_success: 'Cancel recording was successful',
      record_remove_fail: 'Cancel recording failed',
      favorite_add_success: 'Was added successfully',
      favorite_add_fail: 'Adding failed',
      favorite_remove_success: 'Was removed successfully',
      favorite_remove_fail: 'Removing failed',
      notification_add_success: 'Was added successfully',
      notification_add_fail: 'Adding failed',
      notification_remove_success: 'Was removed successfully',
      notification_remove_fail: 'Removing failed',
      purchase_add_success: 'Operation was successfully completed',
      purchase_add_fail: 'Operation failed',
      purchase_remove_success: 'Operation was successfully completed',
      purchase_remove_fail: 'Operation failed',
      service_unstable_connection: 'Unstable connection to server',
      enable_cookies: 'Please enable cookies. ',
      disable_adblock: 'AdBlock can affect the functionality of the site. ' +
      'Please add us to Whitelist in your Ad blocker.'
    }
  }
};

export default en_US;



// WEBPACK FOOTER //
// ./src/locales/dics/en_US.js